if (!customElements.get('mezkui-collection-filters')) {
  customElements.define('mezkui-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.button = this.querySelector('.mezkui-filter-toggle');
      this.layout = this.querySelector('.mezkui-collection-layout');
      if (!this.button || !this.layout) return;
      this.dataset.enhanced = 'true';
      this.button.addEventListener('click', () => this.setOpen(this.button.getAttribute('aria-expanded') !== 'true'));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && matchMedia('(min-width: 750px)').matches && this.button.getAttribute('aria-expanded') === 'true') {
          this.setOpen(false);
          this.button.focus();
        }
      });
    }
    setOpen(open) {
      this.button.setAttribute('aria-expanded', String(open));
      this.button.querySelector('[data-filter-label]').textContent = open ? 'Hide filters' : 'Filter';
      this.button.querySelector('.mezkui-filter-toggle__symbol').textContent = open ? '−' : '+';
      this.layout.classList.toggle('is-filter-open', open);
    }
  });
}
